var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"siss-official-website_v1.0.0_prod"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@sentry_webpack-plugin@1.21.0@@sentry/webpack-plugin/src/sentry-webpack.module.js
// module id = WWTy
// module chunks = 62